import { render } from "./TardyManagementModuleForm.vue?vue&type=template&id=83ad8c28"
import script from "./TardyManagementModuleForm.vue?vue&type=script&lang=js"
export * from "./TardyManagementModuleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__